export const CONTACT = {
  company: "Vridaradhya Hospitality Private Limited",
  address: "Shop No 8, Tower 4, DLF Corporate Greens, Sector 74A, Gurugram 122004",
  phone: "+91 92569 80000",
  email: "Info@forcoamore.com",
  mapsUrl: "https://maps.google.com/?q=DLF+Corporate+Greens,+Sector+74A,+Gurugram+122004",
};

export const HOURS = [
  { days: "Monday – Saturday", time: "Open · 6 days a week" },
  { days: "Sunday", time: "Closed" },
];

export const NAV_LINKS = [
  { label: "Home", href: "/", id: "home" },
  { label: "Our Story", href: "/story", id: "story" },
  { label: "Menu", href: "/menu", id: "menu" },
  { label: "Reservations", href: "/reservations", id: "reservations" },
  { label: "Gallery", href: "/gallery", id: "gallery" },
  { label: "Contact", href: "/contact", id: "contact" },
];

export const IMAGES = {
  hero: "/images/real9-dining.jpeg",
  welcome: "/images/real3.jpeg",
  story: "/images/real2.jpeg",
  reserve: "/images/reserve-candlelit.jpeg",
};

export const HERO_SLIDES = [
  { img: "/images/real9-dining.jpeg", alt: "The warm lantern-lit dining room at Forco Amore" },
  { img: "/images/real7-mural.jpeg", alt: "The hand-painted Forco Amore mural — fresh, delicious, fusion" },
  { img: "/images/real8-cafe.jpeg", alt: "The café corner with bakery counter at Forco Amore" },
];

export const DISHES = [
  {
    name: "Alfredo White",
    desc: "Silky white-sauce pasta — your choice of spaghetti or fettuccine, finished with cracked pepper.",
    img: "https://images.unsplash.com/photo-1707870678076-40ba56a65ece?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBpdGFsaWFuJTIwZm9vZCUyMHBhc3RhJTIwcGl6emF8ZW58MHx8fHwxNzg4MDI1NTA0fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Dal Makhani",
    desc: "Black lentils simmered overnight over a slow flame, finished with white butter and cream.",
    img: "/images/real3.jpeg",
  },
  {
    name: "Chicken Club",
    desc: "Triple-decked chicken and egg mayo on toasted bread, with peri-peri fries.",
    img: "/images/real1.jpeg",
  },
  {
    name: "Margheritta",
    desc: "Tomato, mozzarella and basil — hand-stretched and blistered in our wood-fired oven.",
    img: "https://images.unsplash.com/photo-1574071318508-1cdbab80d002?q=85&w=1000&auto=format&fit=crop",
  },
  {
    name: "Butter Chicken",
    desc: "Tandoor-kissed chicken folded into a velvety tomato-makhani gravy, served with fresh naan.",
    img: "https://images.unsplash.com/photo-1565557623262-b51c2513a641?q=85&w=1000&auto=format&fit=crop",
  },
  {
    name: "Chocolate Truffle Cake",
    desc: "Dark, glossy and decadent — baked fresh in our in-house bakery every morning.",
    img: "https://images.unsplash.com/photo-1578985545062-69928b1d9587?q=85&w=1000&auto=format&fit=crop",
  },
];

export const EXPERIENCE = [
  { icon: "ChefHat", title: "Handmade Pasta", desc: "Rolled, cut and shaped by hand every morning — never from a packet." },
  { icon: "Flame", title: "Tandoor & Wood-Fire", desc: "From oak-fired pizzas to smoky tandoori breads — flame is our first language." },
  { icon: "Coffee", title: "Coffee & Mocktails", desc: "Slow-brewed espressos, spiced chai and zero-proof coolers — our bar pours everything but alcohol." },
  { icon: "UtensilsCrossed", title: "Catering & Events", desc: "Weddings, corporate lunches and celebrations — our kitchen travels with amore." },
];

export const CATERING = {
  overline: "Catering & Events",
  heading: "We Bring the Feast to You",
  text: "From boardroom lunches to big fat weddings, Forco Amore caters experiences your guests will talk about for years. Live counters, copper handis, fusion menus and a team that treats every event like family.",
  points: ["Corporate lunches & office meals", "Weddings & grand celebrations", "Private parties & chef-led live counters"],
  img1: "/images/real5.jpeg",
  img2: "/images/real4.jpeg",
};

export const GALLERY = [
  { img: "https://images.unsplash.com/photo-1563379926898-05f4575a45d8?q=85&w=900&auto=format&fit=crop", label: "Fresh pasta, daily", aspect: "aspect-[4/5]" },
  { img: "https://images.unsplash.com/photo-1513104890138-7c749659a591?q=85&w=900&auto=format&fit=crop", label: "From the wood-fire", aspect: "aspect-square" },
  { img: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?q=85&w=900&auto=format&fit=crop", label: "The coffee bar", aspect: "aspect-[3/4]" },
  { img: "https://images.unsplash.com/photo-1578474846511-04ba529f0b88?q=85&w=900&auto=format&fit=crop", label: "Dolci, always", aspect: "aspect-[4/5]" },
  { img: "/images/real9-dining.jpeg", label: "The dining room", aspect: "aspect-[4/3]" },
  { img: "/images/real4.jpeg", label: "The buffet line", aspect: "aspect-[3/4]" },
  { img: "/images/real2.jpeg", label: "The curry atelier", aspect: "aspect-[4/5]" },
  { img: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=85&w=900&auto=format&fit=crop", label: "Plated with amore", aspect: "aspect-square" },
];

export const GALLERY_FILTERS = [
  { id: "all", label: "All" },
  { id: "food", label: "Food" },
  { id: "space", label: "The Space" },
  { id: "events", label: "Catering & Events" },
];

export const GALLERY_FULL = [
  { img: "/images/real9-dining.jpeg", label: "The dining room", cat: "space", aspect: "aspect-[4/3]" },
  { img: "/images/real1.jpeg", label: "Forco club sandwich", cat: "food", aspect: "aspect-[4/3]" },
  { img: "/images/real7-mural.jpeg", label: "Our story wall", cat: "space", aspect: "aspect-[16/9]" },
  { img: "/images/real3.jpeg", label: "Dal makhani", cat: "food", aspect: "aspect-[4/5]" },
  { img: "/images/real4.jpeg", label: "The buffet line", cat: "events", aspect: "aspect-[3/4]" },
  { img: "https://images.unsplash.com/photo-1563379926898-05f4575a45d8?q=85&w=900&auto=format&fit=crop", label: "Fresh pasta, daily", cat: "food", aspect: "aspect-[4/5]" },
  { img: "/images/real8-cafe.jpeg", label: "The café corner", cat: "space", aspect: "aspect-[3/4]" },
  { img: "https://images.unsplash.com/photo-1513104890138-7c749659a591?q=85&w=900&auto=format&fit=crop", label: "From the wood-fire", cat: "food", aspect: "aspect-square" },
  { img: "/images/real5.jpeg", label: "Copper handi line", cat: "events", aspect: "aspect-[3/4]" },
  { img: "https://images.unsplash.com/photo-1509042239860-f550ce710b93?q=85&w=900&auto=format&fit=crop", label: "The coffee bar", cat: "food", aspect: "aspect-[3/4]" },
  { img: "/images/real6-storefront.jpeg", label: "Find us at DLF Corporate Greens", cat: "space", aspect: "aspect-[4/3]" },
  { img: "/images/real2.jpeg", label: "The curry atelier", cat: "food", aspect: "aspect-[4/5]" },
  { img: "https://images.unsplash.com/photo-1546171753-97d7676e4602?q=85&w=900&auto=format&fit=crop", label: "Zero-proof coolers", cat: "food", aspect: "aspect-[4/5]" },
  { img: "https://images.unsplash.com/photo-1578474846511-04ba529f0b88?q=85&w=900&auto=format&fit=crop", label: "Dolci, always", cat: "food", aspect: "aspect-[4/5]" },
  { img: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=85&w=900&auto=format&fit=crop", label: "Plated with amore", cat: "food", aspect: "aspect-square" },
];

export const INSTAGRAM_TILES = [
  "/images/real1.jpeg",
  "https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?q=85&w=600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1546171753-97d7676e4602?q=85&w=600&auto=format&fit=crop",
  "/images/real5.jpeg",
  "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?q=85&w=600&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1705917893049-157904c1182d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxjaGVmJTIwcGxhdGluZyUyMGRlc3NlcnQlMjB0aXJhbWlzdXxlbnwwfHx8fDE3ODgwMjU1MDR8MA&ixlib=rb-4.1.0&q=85",
];
